import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function CGV() {
  return (
    <main className="min-h-screen bg-white text-gray-900 pt-20">
      <NavBar />

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Conditions Générales de Vente</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          {/* Préambule */}
          <div>
            <p>
              Les présentes Conditions Générales de Vente (ci-après « CGV ») s'appliquent à l'ensemble des
              prestations de services proposées par la société <span className="font-medium">NOXZI</span>, SASU
              au capital de 100,00 €, immatriculée au RCS de Chambéry sous le n° 990 027 377, dont le siège social
              est situé 792 Chemin de Charrière Neuve, 73000 Chambéry, France (ci-après « le Prestataire »), à
              destination de tout client professionnel ou particulier (ci-après « le Client »).
            </p>
            <p className="mt-3">
              Toute commande ou signature d'un devis implique l'acceptation pleine et entière des présentes CGV,
              qui prévalent sur tout autre document émanant du Client, notamment ses propres conditions générales
              d'achat. Les CGV applicables sont celles en vigueur à la date d'acceptation du devis.
            </p>
          </div>

          {/* Art. 1 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 1 — Éditeur</h2>
            <p>Les prestations sont réalisées par :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Société :</span> NOXZI, SASU au capital de 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">RCS :</span> Chambéry — SIREN 990 027 377</li>
              <li><span className="font-medium">Directeur de la publication :</span> Lionel FAURE</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li>
                <span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
            </ul>
          </section>

          {/* Art. 2 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 2 — Prestations proposées</h2>
            <p>NOXZI propose les prestations de services suivantes :</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                <span className="font-medium">Création de sites internet :</span> conception et développement de
                sites vitrine, sites e-commerce, landing pages et applications web sur mesure ;
              </li>
              <li>
                <span className="font-medium">Développement d'applications mobiles :</span> conception et
                développement d'applications iOS et/ou Android natives ou hybrides ;
              </li>
              <li>
                <span className="font-medium">Contrats de maintenance :</span> maintenance corrective et évolutive
                de sites internet et d'applications mobiles, par abonnement mensuel avec engagement minimum de
                6 mois ;
              </li>
              <li>
                <span className="font-medium">Gestion de la présence en ligne :</span> création, optimisation et
                gestion de la fiche Google Business Profile, gestion et animation des comptes sur les réseaux
                sociaux (Facebook, Instagram, LinkedIn, TikTok, etc.), par abonnement mensuel avec engagement
                minimum de 6 mois.
              </li>
            </ul>
            <p className="mt-3">
              Le détail des prestations, leurs modalités techniques et leur tarification sont précisés dans le
              devis ou la proposition commerciale transmis au Client. Les CGV s'appliquent à l'ensemble de ces
              prestations, sauf stipulations contraires expressément mentionnées au devis.
            </p>
          </section>

          {/* Art. 3 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 3 — Commande et formation du contrat</h2>
            <p>
              Toute prestation fait l'objet d'un devis préalable établi par NOXZI et transmis au Client par
              e-mail ou via le Site. Le devis est valable <span className="font-medium">30 jours</span> à compter
              de sa date d'émission, sauf mention contraire y figurant.
            </p>
            <p className="mt-3">
              Le contrat est formé à la date à laquelle le Client retourne le devis signé avec la mention
              « Bon pour accord », accompagné du versement de l'acompte prévu au devis. Aucune prestation ne
              sera débutée avant réception de ces deux éléments.
            </p>
            <p className="mt-3">
              Toute modification de la commande après acceptation du devis devra faire l'objet d'un avenant
              écrit signé par les deux parties et pourra entraîner une révision du prix et/ou du délai.
            </p>
          </section>

          {/* Art. 4 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 4 — Prix et modalités de paiement</h2>

            <h3 className="font-medium mt-4 mb-2">4.1 Prix</h3>
            <p>
              Les prix des prestations sont indiqués en euros hors taxes (HT) et toutes taxes comprises (TTC)
              sur chaque devis. NOXZI se réserve le droit de modifier ses tarifs à tout moment ; les prestations
              sont facturées sur la base des tarifs en vigueur à la date d'acceptation du devis.
            </p>

            <h3 className="font-medium mt-4 mb-2">4.2 Paiement — Prestations à la commande (sites, applications)</h3>
            <p>
              Pour les prestations de création de site internet et de développement d'application mobile,
              les conditions de paiement (montant de l'acompte, jalons intermédiaires, solde à la livraison)
              sont définies librement dans chaque devis en fonction de la nature, de la complexité et du montant
              du projet.
            </p>
            <p className="mt-3">
              L'acompte versé à la commande est non remboursable dès lors que les travaux ont effectivement
              débuté.
            </p>

            <h3 className="font-medium mt-4 mb-2">4.3 Paiement — Abonnements (maintenance, réseaux sociaux, Google)</h3>
            <p>
              Les prestations récurrentes sont facturées mensuellement, à terme à échoir, le 1er de chaque mois.
              La première facture est émise à la date de démarrage de la prestation, au prorata temporis si
              ce démarrage intervient en cours de mois.
            </p>

            <h3 className="font-medium mt-4 mb-2">4.4 Modes de paiement</h3>
            <p>Les paiements sont acceptés par virement bancaire (coordonnées figurant sur chaque facture)
            et par carte bancaire via lien de paiement sécurisé.</p>

            <h3 className="font-medium mt-4 mb-2">4.5 Délais de règlement</h3>
            <p>
              Pour les clients professionnels (B2B), le délai de règlement est de{" "}
              <span className="font-medium">30 jours</span> à compter de la date d'émission de la facture,
              sauf accord contraire au devis. Pour les clients particuliers (B2C), le paiement est exigible
              à réception de la facture.
            </p>
          </section>

          {/* Art. 5 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 5 — Retard et défaut de paiement</h2>
            <p>
              Tout retard de paiement entraîne de plein droit, dès le lendemain de la date d'échéance et sans
              mise en demeure préalable, l'application de pénalités de retard au taux directeur de la Banque
              Centrale Européenne majoré de 10 points de pourcentage.
            </p>
            <p className="mt-3">
              Pour les clients professionnels, une indemnité forfaitaire de recouvrement de{" "}
              <span className="font-medium">40 €</span> est automatiquement appliquée conformément à
              l'article D. 441-5 du Code de commerce. Si les frais réels excèdent ce montant, une
              indemnisation complémentaire sur justificatifs pourra être réclamée.
            </p>
            <p className="mt-3">
              En cas de non-paiement à l'échéance, NOXZI se réserve le droit de suspendre immédiatement
              toutes les prestations en cours, sans préjudice de toute autre voie de droit.
            </p>
          </section>

          {/* Art. 6 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 6 — Obligations du Client</h2>
            <p>Pour permettre la bonne exécution des prestations, le Client s'engage à :</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                Fournir en temps utile l'ensemble des informations et contenus (textes, images, vidéos, logos,
                accès, identifiants, etc.) nécessaires à la réalisation de la prestation ;
              </li>
              <li>
                Désigner un interlocuteur unique disponible, habilité à prendre les décisions nécessaires au
                bon déroulement du projet ;
              </li>
              <li>
                Valider les livrables dans les délais convenus. Passé{" "}
                <span className="font-medium">15 jours ouvrés</span> sans retour écrit, les livrables seront
                considérés comme tacitement acceptés ;
              </li>
              <li>
                Garantir être titulaire des droits sur les contenus et éléments transmis à NOXZI, et garantir
                NOXZI contre tout recours de tiers à ce titre ;
              </li>
              <li>S'acquitter des sommes dues aux échéances convenues ;</li>
              <li>
                Pour les prestations de gestion de réseaux sociaux et Google Business Profile, fournir les
                accès administrateurs aux comptes concernés et répondre aux demandes de validation dans des
                délais raisonnables.
              </li>
            </ul>
            <p className="mt-3">
              Tout retard imputable au Client dans la fourniture des éléments nécessaires pourra entraîner un
              décalage des délais sans engager la responsabilité de NOXZI, et pourra donner lieu à une
              révision du prix si ce retard génère un surcroît de travail documenté.
            </p>
          </section>

          {/* Art. 7 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 7 — Délais de réalisation</h2>
            <p>
              Les délais de réalisation sont indiqués à titre estimatif dans le devis et ne commencent à
              courir qu'à compter de la réception simultanée de l'acompte et de l'ensemble des éléments
              nécessaires transmis par le Client.
            </p>
            <p className="mt-3">
              Ces délais peuvent être repoussés sans indemnité en cas de retard du Client, de modifications
              demandées en cours de projet ou de force majeure.
            </p>
          </section>

          {/* Art. 8 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 8 — Contrats de maintenance</h2>

            <h3 className="font-medium mt-4 mb-2">8.1 Objet</h3>
            <p>
              Le contrat de maintenance couvre, selon la formule souscrite précisée au devis : mises à jour
              des CMS, plugins et librairies ; corrections de bugs ; sauvegardes régulières ; surveillance de
              disponibilité ; interventions correctives dans la limite du volume d'heures mensuel défini au devis.
            </p>

            <h3 className="font-medium mt-4 mb-2">8.2 Durée minimale d'engagement</h3>
            <p>
              Le contrat de maintenance est conclu pour une durée initiale minimale de{" "}
              <span className="font-medium">6 mois</span> à compter de la date de démarrage mentionnée au devis.
              Durant cette période, le contrat ne peut être résilié par le Client sauf faute grave imputable à NOXZI.
            </p>
            <p className="mt-3">
              À l'issue des 6 mois, le contrat se renouvelle automatiquement par périodes mensuelles, résiliable
              par l'une ou l'autre des parties avec un préavis de{" "}
              <span className="font-medium">30 jours</span> par e-mail.
            </p>
            <p className="mt-3">
              En cas de résiliation anticipée par le Client durant la période d'engagement, les mensualités
              restant dues jusqu'au terme des 6 mois seront intégralement facturées.
            </p>

            <h3 className="font-medium mt-4 mb-2">8.3 Exclusions</h3>
            <p>Sont exclus de la maintenance, sauf accord spécifique :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Les développements de nouvelles fonctionnalités ;</li>
              <li>Les refontes graphiques ou restructurations ;</li>
              <li>Les interventions rendues nécessaires par des modifications effectuées par le Client ou un tiers non autorisé ;</li>
              <li>Les problèmes liés à l'hébergeur, au registrar ou au nom de domaine.</li>
            </ul>
          </section>

          {/* Art. 9 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 9 — Gestion des réseaux sociaux et Google Business</h2>

            <h3 className="font-medium mt-4 mb-2">9.1 Périmètre</h3>
            <p>
              La gestion des réseaux sociaux comprend selon la formule : création/optimisation des profils,
              élaboration d'un calendrier éditorial, création de visuels, rédaction et publication des
              contenus, suivi des statistiques et reporting mensuel.
            </p>
            <p className="mt-3">
              La gestion Google Business Profile comprend : création ou revendication de la fiche, optimisation
              des informations, publication de posts, gestion des avis (sous validation du Client) et suivi
              des statistiques.
            </p>

            <h3 className="font-medium mt-4 mb-2">9.2 Durée minimale d'engagement</h3>
            <p>
              Ces abonnements sont conclus pour une durée initiale minimale de{" "}
              <span className="font-medium">6 mois</span>. À l'issue de cette période, ils se renouvellent
              tacitement par mois, résiliables avec un préavis de{" "}
              <span className="font-medium">30 jours</span>.
            </p>
            <p className="mt-3">
              En cas de résiliation anticipée durant la période d'engagement, les mensualités restant dues
              jusqu'au terme des 6 mois seront intégralement facturées.
            </p>

            <h3 className="font-medium mt-4 mb-2">9.3 Validation des contenus</h3>
            <p>
              Le Client dispose de <span className="font-medium">48 heures ouvrées</span> pour valider,
              modifier ou refuser tout contenu soumis par NOXZI. Sans retour dans ce délai, le contenu est
              réputé validé et peut être publié.
            </p>

            <h3 className="font-medium mt-4 mb-2">9.4 Responsabilité éditoriale</h3>
            <p>
              Le Client demeure seul responsable des contenus publiés en son nom. NOXZI ne saurait être tenue
              responsable des conséquences liées aux contenus préalablement approuvés par le Client, ni des
              décisions prises par les plateformes (suspension de compte, modification d'algorithme, etc.).
            </p>

            <h3 className="font-medium mt-4 mb-2">9.5 Fin de contrat et restitution</h3>
            <p>
              À la fin du contrat, NOXZI restitue au Client l'ensemble des accès et lui transfère les contenus
              créés. Les comptes, pages et fiches restent en toutes circonstances la propriété du Client.
            </p>
          </section>

          {/* Art. 10 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 10 — Propriété intellectuelle et cession de droits</h2>

            <h3 className="font-medium mt-4 mb-2">10.1 Droits de NOXZI</h3>
            <p>
              NOXZI conserve la pleine propriété intellectuelle de ses créations, méthodes, outils et
              savoir-faire jusqu'au paiement intégral de la prestation.
            </p>

            <h3 className="font-medium mt-4 mb-2">10.2 Cession au Client</h3>
            <p>
              Après paiement intégral, NOXZI cède au Client les droits d'utilisation sur les livrables (site,
              application, visuels, contenus) pour une utilisation dans le cadre normal de son activité, de
              manière non exclusive. Cette cession ne porte pas sur les frameworks, librairies open-source ou
              outils tiers, régis par leurs propres licences.
            </p>

            <h3 className="font-medium mt-4 mb-2">10.3 Garantie du Client</h3>
            <p>
              Le Client garantit être titulaire des droits sur les éléments qu'il fournit et garantit NOXZI
              contre tout recours de tiers fondé sur ces éléments.
            </p>

            <h3 className="font-medium mt-4 mb-2">10.4 Référence commerciale</h3>
            <p>
              Sauf opposition écrite du Client avant le démarrage, NOXZI peut mentionner la réalisation des
              prestations à titre de référence commerciale (portfolio, site internet, réseaux sociaux).
            </p>
          </section>

          {/* Art. 11 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 11 — Confidentialité</h2>
            <p>
              NOXZI s'engage à garder strictement confidentiels l'ensemble des informations et données transmis
              par le Client, pendant toute la durée du contrat et pour une période de{" "}
              <span className="font-medium">3 ans</span> après son terme.
            </p>
          </section>

          {/* Art. 12 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 12 — Responsabilité de NOXZI</h2>
            <p>
              NOXZI est tenue à une obligation de moyens. Sa responsabilité totale au titre d'un contrat est
              plafonnée au montant des sommes effectivement perçues au titre de ce contrat durant les 12 mois
              précédant le fait générateur.
            </p>
            <p className="mt-3">
              NOXZI ne saurait être tenue responsable des préjudices indirects (perte de chiffre d'affaires,
              perte de clients, préjudice d'image, perte de données) ni des décisions des plateformes tierces
              affectant les services du Client.
            </p>
          </section>

          {/* Art. 13 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 13 — Résiliation</h2>
            <p>
              À l'issue de la période d'engagement de 6 mois, chaque partie peut résilier un abonnement avec
              un préavis de <span className="font-medium">30 jours</span> par e-mail, sans pénalité.
            </p>
            <p className="mt-3">
              En cas de manquement grave non corrigé dans un délai de{" "}
              <span className="font-medium">15 jours</span> suivant mise en demeure par lettre recommandée
              avec accusé de réception, l'autre partie peut résilier le contrat de plein droit et sans indemnité.
            </p>
            <p className="mt-3">
              En cas de résiliation anticipée d'un projet à la commande (site, application) à l'initiative du
              Client pour convenance personnelle, l'acompte versé reste acquis à NOXZI et les sommes
              correspondant aux travaux réalisés restent dues.
            </p>
          </section>

          {/* Art. 14 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 14 — Droit de rétractation (clients particuliers)</h2>
            <p>
              Conformément aux articles L. 221-18 et suivants du Code de la consommation, les clients
              particuliers disposent d'un délai de <span className="font-medium">14 jours</span> à compter de
              l'acceptation du devis pour exercer leur droit de rétractation, sans motif ni pénalité.
            </p>
            <p className="mt-3">
              Si le Client demande expressément le début de la prestation avant l'expiration de ce délai, il
              reconnaît perdre son droit de rétractation en cas d'exécution complète, ou devra régler le
              prorata des travaux réalisés en cas d'exécution partielle.
            </p>
            <p className="mt-3">Ce droit ne s'applique pas aux clients professionnels (B2B).</p>
          </section>

          {/* Art. 15 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 15 — Force majeure</h2>
            <p>
              NOXZI ne pourra être tenue responsable de l'inexécution ou d'un retard en cas de force majeure
              au sens de l'article 1218 du Code civil. Si la force majeure dure plus de 30 jours, chaque partie
              pourra résilier le contrat sans indemnité.
            </p>
          </section>

          {/* Art. 16 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 16 — Droit applicable et règlement des litiges</h2>
            <p>
              Les présentes CGV sont régies par le droit français. En cas de litige, les parties s'engagent à
              rechercher une solution amiable dans un délai de 30 jours.
            </p>
            <p className="mt-3">
              Pour les clients particuliers (B2C) : en cas d'échec amiable, le Client peut recourir gratuitement
              à un médiateur de la consommation (art. L. 611-1 Code de la consommation). Coordonnées du
              médiateur sur demande à{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>. Plateforme
              européenne de résolution en ligne :{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="underline">
                ec.europa.eu/consumers/odr
              </a>.
            </p>
            <p className="mt-3">
              Pour les clients professionnels (B2B) : à défaut d'accord amiable, tout litige est soumis à la
              compétence exclusive des tribunaux du ressort de{" "}
              <span className="font-medium">Chambéry</span>, même en cas de pluralité de défendeurs ou
              d'appel en garantie.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}